import React, { useRef, useState, useEffect } from "react";
import { FaPlay, FaPause } from "react-icons/fa";
import aboutVd from "../../assets/video/0_Resonance_Magnetic_1280x720 (1) (1).mp4";
import AOS from "aos";
import "aos/dist/aos.css";

export default function AboutVideo() {
  const videoRef = useRef(null);
  const [isHovered, setIsHovered] = useState(false);
  const [isPaused, setIsPaused] = useState(true);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    AOS.init({ duration: 1000 });
    const video = videoRef.current;
    const checkStatus = () => setIsPaused(video.paused);

    video.addEventListener("loadeddata", checkStatus);
    return () => video.removeEventListener("loadeddata", checkStatus);
  }, []);

  const togglePlay = () => {
    const video = videoRef.current;
    if (video.paused) {
      video.play();
      setIsPaused(false);
    } else {
      video.pause();
      setIsPaused(true);
    }
  };

  const handleTimeUpdate = () => {
    const video = videoRef.current;
    const current = (video.currentTime / video.duration) * 100;
    setProgress(current || 0);
  };

  const handleSeek = (e) => {
    const video = videoRef.current;
    const newTime = (e.target.value / 100) * video.duration;
    video.currentTime = newTime;
  };

  return (
    <div className="py-4 sm:py-6 md:py-8 lg:py-12 xl:py-[5rem]">
      <div className="px-4 py-6 sm:px-6 sm:py-8 md:px-8 md:py-10 lg:px-10 lg:py-12 max-w-7xl mx-auto">
        <div className="flex justify-center" data-aos="fade-up">
          <div className="w-full max-w-5xl">
            <div
              className="relative w-full pb-[56.25%] overflow-hidden rounded-3xl shadow-lg group"
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
              onClick={() => setIsHovered(true)} // Show controls on tap for mobile
            >
              <video
                ref={videoRef}
                className="absolute top-0 left-0 w-full h-full object-cover"
                muted={false}
                playsInline
                onClick={togglePlay}
                onPlay={() => setIsPaused(false)}
                onPause={() => setIsPaused(true)}
                onTimeUpdate={handleTimeUpdate}
              >
                <source src={aboutVd} type="video/mp4" />
                Your browser does not support the video tag.
              </video>

              {/* Custom Controls */}
              {(isHovered || window.innerWidth < 768) && (
                <>
                  <input
                    type="range"
                    value={progress}
                    onChange={handleSeek}
                    onClick={(e) => e.stopPropagation()}
                    className="absolute bottom-20 sm:bottom-24 md:bottom-28 lg:bottom-[130px] left-0 w-full appearance-none h-1 sm:h-1.5 bg-gray-300 accent-blue-500 cursor-pointer z-10"
                  />
                  <div className="absolute bottom-4 sm:bottom-5 md:bottom-6 left-1/2 transform -translate-x-1/2 z-10">
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        togglePlay();
                      }}
                      className="bg-[#cfa751] text-white p-3 sm:p-4 md:p-5 rounded-full transition"
                    >
                      {isPaused ? (
                        <FaPlay className="w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6" />
                      ) : (
                        <FaPause className="w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6" />
                      )}
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}